<template>
  	<div class="create-post scrollbar" v-if="postDialog && !showcommentpage">
    	<v-overlay opacity="0.8">
        <div class="overlay-content">

            <div >
          	<v-row style="margin: auto; padding: auto">
            <v-col> </v-col>
            <v-col>
            	<v-row>
            	<div class="create-content-dialog">

                <div v-if="isDatapresent" class="loader">
                <v-progress-circular
                    :width="6"
                    :size="80"         
                    color="green"
                    indeterminate
                ></v-progress-circular>
                </div> 
					   <div v-else :key = "1">
                 	<div>     
                    <v-container>
                      	<v-row>
                        <v-col cols="1" class="avatar-con mr-6">
                            <v-avatar class="avatar" tile size="38">
                                <img class="farmer-avatar " :src="querydata.user.image ? querydata.user.image.thumbnail : dummyAvatar" alt="" referrerpolicy="no-referrer"/>
                            </v-avatar>
                        </v-col>
                        <v-col cols="9">
                            <div class="name">
                            <v-row>
                                <label class="--font" style="font-weight: 500">  
                                    {{querydata.user.name}}
                                </label>
                            </v-row>
                            <v-row>
                                <small class="secondary-font lowerText">
                                    {{querydata.user.location_name}}
                                    <time-ago class="ml-10" :datetime="querydata.post.published_at" long></time-ago>
                              	</small>
                            </v-row>
                            </div>
                        </v-col>
                        <v-spacer/>
                      	</v-row>
                    </v-container>
                  	</div>
                  	<div>
                    	<p class="--font query-text">
                    	  	{{querydata.post.description}}
                    	</p>
                  	</div>
                    <!-- query image section  -->
                    <!-- height="260px" -->
                  	<div v-if="querydata.post.media.length > 0">
                        <v-carousel
                            style="border-radius: 8px; height:260px"
                            hide-delimiter-background
                            hide-delimiters
                            v-if="querydata.post.media.length == 1"
                            :prev-icon=true
                            :next-icon=true
                        >
                            <v-carousel-item
                                v-for="(item, i) in querydata.post.media" :key="i"
                            >   
                                <img 
                                    @click="showbigimage(item)"
                                    class="post_image"
                                    :key="i"
                                    :src = "item.media_type === 'farmstock_video' ? item.thumbnail_url : item.url"
                                >

                            </v-carousel-item>
                        </v-carousel>

                                <div v-if="showimage">
                                <v-overlay  opacity="0">
                                  <div class="big_post_image_con">
                                  <img 
                                    :src = "src"
                                    class="big_post_image"
                                />
                                  </div>
                                  <button class="closeBtn" @click="handlebigimgclose">
                  	                  Close
                                  </button>
                                  
                                </v-overlay>
                                </div>

                        <v-carousel             
                            style="border-radius: 8px; height:260px" 
                            hide-delimiter-background
                            hide-delimiters
                            v-if="querydata.post.media.length >= 2"

                        >   
                            <v-carousel-item
                                v-for="(item, i) in querydata.post.media" :key="i"
                            >
                                <img
                                    @click="showbigimage(item)"
                                    class="post_image"
                                    :key="i"
                                    :src = "item.media_type === 'farmstock_video' ? item.thumbnail_url : item.url"
                                />
    
                            </v-carousel-item>
                        </v-carousel>

                        <div v-if="showimage">
                                  <div class="big_post_image_con">
                                  <img :src = "src" class="big_post_image">
                                  </div>
                                  <button class="closeBtn" @click="handlebigimgclose">
                  	                  Close
                                  </button>
                                  
                                </div>

                    </div>

                    <div style="margin: 1rem; margin-top: 1.6rem">
                    <v-row>
                      	<small v-if="querydata.post.stats" class="bold" style="color: #a5afa9">
                            {{querydata.post.stats.post_like_count}} Likes .
                            {{querydata.post.stats.post_comment_count}} Comments .
                            {{querydata.post.stats.post_share_count}} Shares .
                        </small>
                    </v-row>
                    <v-row>
                        <div class="text-filed-con" :style="{'z-index': textfieldzindex}">
                        <v-text-field 
                            class="mt-4"
                            @click:append="addNewComment(querydata.post.id)"
                            @keyup.enter="addNewComment(querydata.post.id)"
                            light 
                            v-model="newCommentText"
                            outlined placeholder="Add a comment..." 
                            background-color="#F6F9F6"
                            append-icon="mdi-send"
                        ></v-text-field>
                        </div>
                    </v-row>
                    <v-row>
                      <button
                          @click="showcommentpage = true"
                          class="--green draft mt-0 pointer"
                      >
                          View and manage comments
                      </button>
                    </v-row>
                    </div>
                  </div>
                </div>


                <!-- Show the thred of comment  -->
             
            </v-row>
            <v-row>
                <button class="closeBtn" 
                    @click="close"
                >
                  	Close
                </button>
            </v-row>
            </v-col>
            <v-col> </v-col>
          	</v-row>
            </div>
        </div>
    </v-overlay>
   
  	</div>
    <div v-else>
        <show-comments :showpost='showcommentpage' :id="querydata.post.id" @closecommentpage="closeall" @closecomment="showcommentpage=false"/>
    </div>

</template>

<script>
//import func from 'vue-editor-bridge';
import { TimeAgo } from "vue2-timeago";
import { mapActions } from "vuex";
import showcomments from "./showcomments";
import API_URL from "../../../../helpers/apiUrls";
import accessToken from "../../../../helpers/accessToken";
export default {
  	name:'viewpost',

    data() {
        return{
            showcommentpage: false,
            showimage : false,
            dummyAvatar : require("../../../../assets/DummyAvatar.png"),
            textfieldzindex : 1,
            newCommentText : "",
            src: "",
            isDatapresent : false,        
        }
    },
    props:{
        postDialog: Boolean,
        querydata : Object,
    },
  	components:{
   		"time-ago": TimeAgo,
        "show-comments" : showcomments,
  	},
    methods:{
        ...mapActions("queryStore", ['toggledialog', 'toggledreplyialog']),
        hidepost(){
            this.toggledialog()
        },
        showbigimage(item){
            this.src = item.media_type === 'farmstock_video' ? item.thumbnail_url : item.url,
          this.showimage = true,
          this.textfieldzindex = -1
        },
        handlebigimgclose(){
          console.log("HANDKE BIG IMAGE CLICKED");
          this.showimage = false,
          this.textfieldzindex = 1
        },
        showreply(){
            this.toggledreplyialog()   
        },
        close(){
            this.$emit('close');
        },
        openpostpage(){
          this.showcommentpage=true
        },
		    closeall(){
			    this.showcommentpage=false
			    this.$emit('close');
		    },

        // add a new comment in thread
        addNewComment(id){
            this.isDatapresent = true;
            console.log("TIUFJKGJEKLNHJEH", this.isDatapresent);
            const successHandler = (response) => {
                if (response.status === 200) {
                    this.isDatapresent = false;
                    console.log("RESPONSE", response);
                    this.newCommentText = "";
                }
            };
            const errorHandler = (error) => {
                this.showToast('Something went wrong internally!', 'error', 10000);
                console.log(error);
                this.isDatapresent = false;
            };

            const data = {
                feed_type : "post_feed",
                comment: this.newCommentText,
                post_id: id,
                comment_author_type: "business",
                business_id: `${localStorage.getItem("Brand-ID")}`,
            };
            console.log("NEW COMMENT DATA --> ", data);

            const headers = {
                Authorization: `Bearer ${accessToken.getAccessToken()}`,
            };

            this.requestPOST(
                API_URL.createContent__comment,
                data,
                headers,
                successHandler,
                errorHandler
            );
        },
    },
    watch:{
        // querydata:function(){
        //     console.log(this.querydata);
        // }
    },  
    computed: {
     	postDetails() {
        	return this.$store.getters["queryStore/GET_POST_DETAILS"];
    	},
    },
}
</script>


<style lang="scss" scoped>
.create-content-dialog {
  background-color: white;
  font-family: Roboto;
  padding: 20px;
  margin-top: 0rem;
  width: 550px;
  max-height: 600px;
  margin-bottom: 1rem;
  border-radius: 4px;
  overflow-y: auto;
  overflow-x: hidden;

}
.text-filed-con{
  width: 100%;
}
.loader{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 300px;
}
.overlay-content {
  //background-color: grey;
  margin: auto;
  padding: auto;
  position: relative;
  top: 25%; /* 25% from the top */
  width: 100%; /* 100% width */
  text-align: center; /* Centered text/links */
  //margin-top: 30px; /* 30px top margin to avoid conflict with the close button on smaller screens */
}
.draft {
  background: rgba(49, 138, 54, 0.05);

  // background: #f1f6f4;
  border-radius: 5px;
  width: 100%;
  height: 60px;
}
.post_image{
    width: 100%;
    height: 100%;
    object-fit: cover;
    cursor: pointer;
}
.big_post_image_con{
  padding: 15px 15px;
  z-index: 10;
  height: 610px;
  min-width: 600px;
  background-color: #ffffff;
  margin-bottom: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 3px;
}
.big_post_image{
  height: 100%;
  border-radius: 3px;
}
.query-text{
    font-size: 16px;
    font-weight: 400;
    margin-top: 0.6rem;
    text-align: left;
    word-wrap: break-word;
    color: #445149;
}
.avatar-con {
  margin-right: 1rem;
  margin-left: -1rem;
}

.avatar {
  img{
    border-radius: 3px;
  } 
}
.name {
  margin-top: 0.5rem;
}
.icon {
  //align-items: flex-end;
  justify-content: flex-end;
}

.add {
  background: #f4faf7;
  padding: auto;
  margin-top: auto;
}

.v-input input {
  max-height: 32px;
  background-color: aquamarine !important;
}
.iconBtn {
  width: 30px !important;
  font-size: 4rem;
  margin-top: 50%;
}
.closeBtn {
  background-color: #ffffff;
  width: 185px;
  margin: auto;
  height: 55px;
  border-radius: 33px;
  color: #9e9f9e;
  font-size: 18px;
  font-weight: 400;
}
.comment-dialog {
  background-color: white;
  color: black;
  font-family: Roboto;
  // padding: 20px;
  margin-top: 0rem;
  width: 700px;
  margin-bottom: 1rem;
  border-radius: 4px;
}
// For ScrollBar Style
.scrollbar{
::-webkit-scrollbar {
  width: 15px;
  margin: 3px;
  border-left: 1px solid rgba(50, 52, 65, 0.1);
  border-right: 1px solid rgba(50, 52, 65, 0.1);
}

::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: rgba(50, 52, 65, 0.15);
  border: 4px solid transparent;
  background-clip: content-box;
}
::-webkit-scrollbar-track {
  width: 15px;
}
::-webkit-scrollbar-corner {
  display: none;
  height: 0px;
  width: 0px;
}
}
</style>
